export default __webpack_public_path__ + "static/yfi-e731de769d813b9e561f6c02cd97111d.png";